export function getEmailEnding(email = null) {
  return email.split("@")[1].replace(".", "");
}

export function getUsername(email) {
  return email.split("@")[0].replace(".", "");
}
